module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.f82772c2.jpg";